import React from 'react';
import { Field } from 'formik';

import { FormErrorUI, FormLabelUI, InputUI } from '../Interface';

const ProvinceFields = ({ viewField, values, errors }) => {
  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-4 mx-4 mb-5">
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Tartománynév" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          InputLabelProps={{ shrink: values.name !== '' }}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default ProvinceFields;
